import DotLoader from 'react-spinners/DotLoader'
import { Flex } from '@pancakeswap/uikit'
import Page from 'views/Page/Page'
import 'animate.css'
import { PoolsHeader } from './styled'
import dynamic from 'next/dynamic'
import { useGetStakersQuery } from 'graphql/data/generated/graphql-codegen-generated'
import { backendClient } from 'graphql/data/util'
import useActiveWeb3React from 'hooks/useActiveWeb3React'

const PoolsTable = dynamic(() => import('./components/PoolsTable/PoolsTable'), { ssr: true })

const Pools: React.FC = () => {
  const { account, chainId } = useActiveWeb3React()

  const { data, loading, error, previousData } = useGetStakersQuery({
    pollInterval: 30000,
    client: backendClient,
    variables: {
      chainId,
      account,
    },
  })

  if (error) console.log(error)

  return (
    <>
      <Page>
        <PoolsHeader>Earn</PoolsHeader>

        {!data ? (
          <Flex justifyContent="center" mb="4px">
            <DotLoader
              color="#37C0DF"
              size={25}
              aria-setsize={12}
              speedMultiplier={1}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </Flex>
        ) : (
          <PoolsTable pools={data} account={account} />
        )}
      </Page>
    </>
  )
}

export default Pools
